//@author: mandy
import { Cache } from "../../decorators/cache.decorator";
import { S25Util } from "../../util/s25-util";
import { DataAccess } from "../../dataaccess/data.access";
import { jSith } from "../../util/jquery-replacement";
import { Timeout } from "../../decorators/timeout.decorator";
import { Image } from "../../pojo/Image";

export class S25ImageService {
    public static BootstrapDefault = {
        point: "sm",
        numCols: 3,
    } satisfies Image.BootstrapOptions;

    /** Extract imageId from a URL built by getUrl/getUrlExternal (e.g. from ingestion form or Trumba). Returns undefined if not our format. */
    public static parseImageIdFromUrl(url: string): number | undefined {
        const match = String(url).match(/[?&]image_id=(-?\d+)/);
        if (!match) return undefined;
        const n = parseInt(match[1], 10);
        return !isNaN(n) && !!n ? n : undefined;
    }

    @Cache({ targetName: "S25ImageService" })
    public static getUrl(imageId: number, width?: string | number) {
        return (
            DataAccess.injectCaller(
                DataAccess.getUrl(
                    "/image?image_id=" + imageId + (width ? DataAccess.composeParam("width", width) : ""),
                ),
                "S25ImageService.getUrl",
            ) +
            "&" +
            new Date().getTime()
        );
    }

    public static getUrlExternal(imageId: number) {
        return `${DataAccess.getUrl("/image?image_id=" + imageId)}&fileName=`;
    }

    @Cache({ targetName: "S25ImageService" })
    public static getUrlBootstrapWidth(imageId: number, bootstrap: Image.BootstrapOptions) {
        return S25ImageService.getUrl(imageId, S25ImageService._getBootstrapWidth(bootstrap));
    }

    @Timeout
    @Cache({ targetName: "S25ImageService" })
    public static getLoaded(imageId: number, width: number | undefined) {
        return jSith.when({ isLoaded: false });
    }

    @Cache({ targetName: "S25ImageService" })
    public static getLoadedBootstrapWidth(imageId: number, bootstrap: Image.BootstrapOptions) {
        return S25ImageService.getLoaded(imageId, S25ImageService._getBootstrapWidth(bootstrap));
    }

    public static _getBootstrapWidth(bootstrap: Image.BootstrapOptions) {
        return S25Util.bootstrap.getColMaxWidth(
            (bootstrap && bootstrap.point) || S25ImageService.BootstrapDefault.point,
            (bootstrap && bootstrap.numCols) || S25ImageService.BootstrapDefault.numCols,
            bootstrap && bootstrap.maxWidth,
        );
    }
}
